import BulkOperationModule from '@/modules/bulk-operation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/bulk-operation')({
  component: BulkOperationPage,
});

function BulkOperationPage() {
  return <BulkOperationModule />;
}
